"use client";

export default function Error({ reset }: { reset: () => void }) {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center space-y-4">
        <p className="text-foreground font-medium">エラーが発生しました</p>
        <p className="text-muted-foreground text-sm">しばらく時間をおいてから再度お試しください。</p>
        <button
          onClick={reset}
          className="text-sm text-primary underline-offset-4 hover:underline"
        >
          再試行
        </button>
      </div>
    </div>
  );
}
